import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
  userService,
  riskDataService,
  riskSharedModelService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon
} from 'app/components/global';
import riskMain from './riskMain';
import editRiskDialog from './dialog.editRiskDialog';
import controller from './risk-admin.controller';
import directive from './risk-admin.directive';
import settingsDialog from './dialog.settingsDialog';


export const riskAdminRouteConfig = {
  template: require('./risk-admin.html'),
  controller: 'RiskAdminController',
  controllerAs: 'riskAdminVM',
};

export default angular.module('app.components.admin.riskAdmin', [
  alerts,
  actionIcon,
  editRiskDialog,
  importDocument,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  riskDataService,
  riskSharedModelService,
  riskMain,
  settingsDialog,
])
  .directive('riskAdmin', directive)
  .controller('RiskAdminController', controller)
  .name;

console.log('app.components.admin.riskAdmin created');
